export const CUSTOMERS_TABLE = 'customermaster';
export const CUSTOMERS_TABLE_LOOKUP = 'customermaster-lookup';
export const CONTRACT_DETAILS_TABLE = 'contractdetails';
export const PRODUCT_TABLE = 'product';
export const CUSTOMER_PRODUCT_TABLE = 'customerproduct';
export const QUOTE_TABLE = 'quote';
export const ABG_QUOTING_APPROVERS = 'abgquotingapprovers';
export const ABG_QUOTING_BRANDS = 'ABGQuotingBrands';
export const ABG_CUSTOMER_BRANDS = 'ABGCustomerBrands';
export const ABG_CUSTOMER_TIERS = 'ABGCustomerTiers';
export const ABG_CUSTOMER_CHANNELS = 'ABGCustomerChannels';
export const ABG_DIRECTORS = 'ABGQuotingDirectors';
export const ABG_PROJECT_TYPES = 'ABGProjectType';
export const ABG_REP_AGENCIES = 'ABGRepAgencies';
export const CLIENT_ID = 'abg-retail' as const;
export const FILE_ACCESS = 'fas' as const;
export const CONTRACT_DOCUMENT_TYPE = 'contract';
export const DRAFT_CONTRACT_DOCUMENT_TYPE = 'draft-contract';
export const DRAFT_NAME_CHANGE_DOCUMENT_TYPE = 'draft-name-change';
export const CUSTOMER_TO_DELETE_DOCUMENT_TYPE = 'customer-delete';
export const DATASTORE_DOCUMENT = 'document';

export const START_OF_WEEK = 1; // Monday
